import React, { useEffect, useState } from "react";
import axios from "../../Utilities/axios";
import { useTypewriter, Cursor } from "react-simple-typewriter";
import { useNavigate } from "react-router-dom";
import "./Navbar.css";
import { CSSTransition } from "react-transition-group";
import Slider from "../hero/slider/Slider";
import SpinnerPage from "./SpinnerPage";
import AOS from "aos";
import "aos/dist/aos.css";

const Hero = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);

  let availableHotel;

  const navigation = useNavigate();
  let dates;
  let value;

  const getHotels = async (event) => {
    event.preventDefault();
    setIsLoading(true);
    const mainAvailableHotel = await axios.get(
      `/registrations/hotels?sourceType=showInCompanySite&hotelGroupName=Residency`,
    );
    // setAvailableHotel(availableHotel.data)

    availableHotel = mainAvailableHotel.data;
    setIsLoading(false);
    navigation("/availablehotels", {
      state: { availableHotel: availableHotel },
    });
  };

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  useEffect(() => {
    AOS.init({ duration: 2000 });
  }, []);

  const [text] = useTypewriter({
    words: ["Luxury and Comfort stay"],
    //   loop: {},
    //  typeSpeed: 120,
    //  deleteSpeed: 80
  });

  return (
    <>
      {isLoading && <SpinnerPage />}
      <section className="hero home-hero">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div className="copy">
                <div className="text-label">
                  Book A Hotel At Residency Hotels Limited
                </div>
                <div className="text-hero-bold">
                  For Your {text}
                  <Cursor />
                </div>
                <div className="text-hero-regular">
                  Residency Hotel is a premier accommodation option that offers
                  a comfortable and luxurious stay for travelers. Located in a
                  prime location, it provides convenient access to various
                  attractions and amenities in the area. At Residency Hotel,
                  guests can expect top-notch hospitality and impeccable
                  service.
                  {isExpanded ? (
                    <CSSTransition
                      in={isExpanded}
                      timeout={300} // Adjust the animation duration as needed
                      classNames={{
                        enter: "fade-enter",
                        enterActive: "fade-enter-active",
                        exit: "fade-exit",
                        exitActive: "fade-exit-active",
                      }}
                      unmountOnExit
                    >
                      <span>
                        The hotel boasts well-appointed rooms and suites,
                        designed to provide a relaxing and enjoyable experience.
                        Each room is equipped with modern amenities, ensuring a
                        comfortable stay for both leisure and business
                        travelers. The hotel also features a range of facilities
                        and services to cater to the needs of its guests. These
                        may include a fitness center, swimming pool, spa,
                        business center, conference rooms, and multiple dining
                        options offering delicious cuisine. Residency Hotel
                        prides itself on its attentive and friendly staff who
                        are dedicated to ensuring a memorable stay for every
                        guest. Whether you're traveling for business, leisure,
                        or a special occasion, Residency Hotel strives to create
                        an ambiance of comfort and luxury. Overall, Residency
                        Hotel aims to provide a welcoming and homely
                        environment, offering a perfect blend of comfort,
                        convenience, and personalized service for a truly
                        remarkable stay
                      </span>
                    </CSSTransition>
                  ) : null}
                </div>
                <div className="cta">
                  <button
                    onClick={(event) => getHotels(event)}
                    className="btn btn-primary shadow-none"
                  >
                    {" "}
                    Book Now{" "}
                  </button>
                  <button
                    onClick={toggleExpand}
                    className="btn btn-secondary shadow-none ms-3"
                  >
                    {" "}
                    {isExpanded ? "Less Details" : "More Details"}{" "}
                  </button>
                </div>
              </div>
            </div>
            <div className="col-md-6 images  ">
              <Slider />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Hero;
